import React from "react";
import {
  FaPhp,
  FaPython,
  FaReact,
  FaDocker,
  FaAws,
  FaGitAlt,
  FaJoomla,
  FaShopify,
  FaDatabase,
  FaTools,
  FaCode,
} from "react-icons/fa";
import {
  SiJavascript,
  SiLaravel,
  SiOdoo,
  SiWordpress,
  SiPrestashop,
  SiZoho,
  SiMongodb,
  SiNextdotjs,
  SiNestjs,
  SiSymfony,
  SiMysql,
} from "react-icons/si";

// Liste complète de tes outils/langages/frameworks
const skills = [
  { name: "WordPress" },
  { name: "Oxygen Builder" },
  { name: "Elementor" },
  { name: "Prestashop" },
  { name: "Joomla" },
  { name: "Shopify" },
  { name: "MERN" },
  { name: "ReactJS" },
  { name: "Next.js" },
  { name: "NestJS" },
  { name: "Symfony" },
  { name: "Laravel" },
  { name: "Odoo" },
  { name: "Zoho" },
  { name: "PHP" },
  { name: "JavaScript" },
  { name: "Python" },
  { name: "MySQL" },
  { name: "Gestion serveurs & réseaux" },
  { name: "SEO" },
  { name: "Docker" },
  { name: "Git" },
  { name: "AWS" },
];

// Mapping des logos disponibles
const iconMap = {
  WordPress: <SiWordpress color="#21759b" />,
  Prestashop: <SiPrestashop color="#df0067" />,
  Joomla: <FaJoomla color="#5091cd" />,
  Shopify: <FaShopify color="#7ab55c" />,
  ReactJS: <FaReact color="#61dafb" />,
  MERN: <SiMongodb color="#47a248" />, // Représente MERN par MongoDB
  "Next.js": <SiNextdotjs color="#000" />,
  NestJS: <SiNestjs color="#e0234e" />,
  Symfony: <SiSymfony color="#000" />,
  Laravel: <SiLaravel color="#ff2d20" />,
  Odoo: <SiOdoo color="#874e9c" />,
  Zoho: <SiZoho color="#e94e1b" />,
  PHP: <FaPhp color="#777bb4" />,
  JavaScript: <SiJavascript color="#f7df1e" />,
  Python: <FaPython color="#306998" />,
  MySQL: <SiMysql color="#00758f" />,
  Docker: <FaDocker color="#0db7ed" />,
  Git: <FaGitAlt color="#f05032" />,
  AWS: <FaAws color="#ff9900" />,
  Elementor: <FaTools color="#92003b" />, // Icône générique outil
  "Oxygen Builder": <FaTools color="#3aafa9" />,
  "Gestion serveurs & réseaux": <FaDatabase color="#2c5364" />,
  SEO: <FaCode color="#007bff" />,
};

const getInitials = (text) =>
  text
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase();

const TechLogos = () => (
  <div className="skills-logos-grid">
    {skills.map((skill) => (
      <div className="skill-logo-item" key={skill.name} title={skill.name}>
        <div className="skill-logo-icon">
          {iconMap[skill.name] || (
            <span className="skill-logo-fallback">
              {getInitials(skill.name)}
            </span>
          )}
        </div>
        <div className="skill-logo-label">{skill.name}</div>
      </div>
    ))}
  </div>
);

export default TechLogos;
